import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var NoInstantAnswerSection = function NoInstantAnswerSection() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionHeaderSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "s9WPlu",
    defaultMessage: [{
      "type": 0,
      "value": "Vamos encontrar respostas para resolver o seu problema"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "prdLd3",
    defaultMessage: [{
      "type": 0,
      "value": "Para uma resposta mais rápida, consulte os artigos relacionados listados abaixo. Ainda tem dúvidas? Contacte-nos para obter mais ajuda."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "5x"
  }));
};